export class Payload<T> {
    message: string;
    value: T;
}
